import { SELECT_PRODUCT_COLOUR } from '../constants/ActionTypes'

export default function selectProductColour(productColour, lineNumber) {
    return {
        type: SELECT_PRODUCT_COLOUR,
        productColour,
        lineNumber
    }
}
